import _ from 'lodash';

import { SET, CLEAR_PAGE_DATA, UPDATE_PURCHASE_ORDER } from './action-types';
import { updateItemInList } from 'utils/reducer-utils';


export default function reducers(state = {}, action = { data: {} }) {
  switch (action.type) {
    case SET:
      _.assign(state, action.data);
      break;
    case CLEAR_PAGE_DATA:
      return {};
    case UPDATE_PURCHASE_ORDER:
      state.purchaseOrders = updateItemInList(state.purchaseOrders, action.purchaseOrder.id, () =>
        _.cloneDeep(action.purchaseOrder)
      );
      break;
    default:
      return state;
  }

  return { ...state };
}



// WEBPACK FOOTER //
// ./app/routes/purchases/store/reducers.js